import { useSubscriptionContext } from '../../../contexts/SubscriptionContext';
import { MODULE_CONFIG, MODULE_KEYS_ORDERED } from '../../../config/subscriptionConfig';

export const ActiveModulesSection = () => {
    const { isModuleActive, isTrialActive } = useSubscriptionContext();

    const coreModules = [
        { name: 'Inspections', active: true },
        { name: 'Equipment', active: true },
        { name: 'Daily Briefing', active: true },
        { name: 'Reports', active: true },
    ];

    return (
        <section className="settings-section">
            <div className="settings-section-header">
                <div>
                    <h2 className="settings-section-title">Active Modules</h2>
                    <p className="settings-section-subtitle">Modules currently available in your account</p>
                </div>
            </div>

            <div className="settings-section-body">
                <div className="active-modules-grid">
                    {/* Core modules — always active */}
                    {coreModules.map((mod) => (
                        <div key={mod.name} className="active-module-item active-module-item--active">
                            <span className="active-module-icon">✓</span>
                            <span className="active-module-name">{mod.name}</span>
                            <span className="active-module-status active-module-status--active">Active</span>
                        </div>
                    ))}

                    {/* Add-on modules */}
                    {MODULE_KEYS_ORDERED.map((key) => {
                        const config = MODULE_CONFIG[key];
                        const active = isModuleActive(key) || isTrialActive;
                        return (
                            <div
                                key={key}
                                className={`active-module-item ${active ? 'active-module-item--active' : 'active-module-item--locked'}`}
                            >
                                <span className="active-module-icon">{active ? '✓' : '🔒'}</span>
                                <span className="active-module-name">{config.name}</span>
                                <span className={`active-module-status ${active ? 'active-module-status--active' : 'active-module-status--locked'}`}>
                                    {active ? 'Active' : 'Not Active'}
                                </span>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
